import * as React from 'react';
import './TabTitleForSearch.scss';

interface ITabTitleProps {
  title: string;
  count?: number;
  showCount?: boolean;
  disabled?: boolean;
  searchTitle: string;
  searchHandler: (e: any) => void;
}

export function TabTitleForSearch(props: ITabTitleProps) {
  const disabled = props.disabled != null ? props.disabled : false;
  return (
    <button  className="rp-tabtitle-search">
      <div className="search-tab-container">
        <div className={'rp-tabtitle--title' + (disabled ? ' disabled' : '')}>{props.title}</div>
        {props.showCount ? (
        <div className={'rp-tabtitle--count' + (disabled ? ' disabled' : '')}>{props.count}</div>
        ) : null}
        <div className="search-tab-column">
        <input aria-label="Models Search Part" 
            name="searchSearchModel" 
            className='search-search-input' 
            type="text" 
            placeholder={props.searchTitle}
            onChange={(e) => props.searchHandler(e.target.value)}
            />
        </div>
      </div>
    </button>
  );
}
